import {emptyValidator, formValidator} from "../../validators";

const customerShipperVatidationStatus ={
    cshCustomer:{
      validators: [emptyValidator()],
      name: "Customer"
    },
    cshShipper:{
        validators: [emptyValidator()],
        name: "Shipper"
    },
    cshActive: {
        validators: [emptyValidator()],
        name: "Active",
    },
    cshStatus: {
        validators: [emptyValidator()],
        name: "Status",
    },

};
export const CustomerShipperValidation= (customerShipperData) => {
    return formValidator(customerShipperData, customerShipperVatidationStatus);
}
